var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.type === 'candidate')?_c('index-candidate'):(_vm.user)?_c('index-auth'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }